import type { SetOpenPopup } from './actions';
import { PopupActionTypes } from './actionTypes';
import type { PopupTypes } from './types';

export const setOpenPopup = (popupType: PopupTypes): SetOpenPopup => ({
  type: PopupActionTypes.SET_OPENED_POPUP,
  payload: popupType,
});
